module.exports = __webpack_public_path__ + "img/new-title.0ce38f81.png";